import { createObservability } from '../../createObservability';
import type { IObservability } from '../../createObservability';
import { ConsoleAnalyticsProvider } from '../ConsoleAnalyticsProvider';
import { ConsoleErrorProvider } from '../ConsoleErrorProvider';
import { initOpenTelemetry, type IOtelInitOptions } from './initOpenTelemetry';
import { OtelLoggerProvider } from './OtelLoggerProvider';
import { OtelMetricsProvider } from './OtelMetricsProvider';
import { OtelTracingProvider } from './OtelTracingProvider';

/**
 * Composition root: metrics + tracing + logger via OpenTelemetry;
 * errors / analytics continuam console (Sentry depois se quiser).
 */
export function createOtelObservability(options?: IOtelInitOptions): IObservability {
  initOpenTelemetry(options);
  return createObservability({
    metrics: new OtelMetricsProvider(),
    logger: new OtelLoggerProvider(),
    errors: new ConsoleErrorProvider(),
    tracing: new OtelTracingProvider(),
    analytics: new ConsoleAnalyticsProvider(),
  });
}
